// extracted by mini-css-extract-plugin
export default {"root":"send-button_root__g-zUV","input":"send-button_input__A2FD5","button":"send-button_button__XgFg9"};